import { QUALITY_LABEL, SPEED_LABEL, generatorById, type GeneratorInfo } from '@ai-studio/shared';

/**
 * Speed and quality of a local generator as two small tags
 * ("Very slow" / "Best quality"). The tooltip says what it is best at.
 */
export function GeneratorTag({ gen, time = false }: { gen: GeneratorInfo; time?: boolean }) {
  return (
    <span className="gen-tags" title={`${gen.label}: ${gen.specialty}${time ? '' : ` (${gen.time})`}`}>
      <span className={`gen-tag gen-speed-${gen.speed}`}>{SPEED_LABEL[gen.speed]}</span>
      <span className={`gen-tag gen-quality-${gen.quality}`}>{QUALITY_LABEL[gen.quality]} quality</span>
      {time && <span className="gen-tag gen-time">{gen.time}</span>}
    </span>
  );
}

/** Tags for a generator id (renders nothing for an unknown id). */
export function StageTag({ id, time = false }: { id: string; time?: boolean }) {
  const gen = generatorById(id);
  return gen ? <GeneratorTag gen={gen} time={time} /> : null;
}
